import { createSelector } from 'reselect'
// import { List } from 'immutable'
const headerSelector = state => state.get('header')

export const getIsHide = createSelector(
  headerSelector,
  headerImmutable => {
    const header = headerImmutable.toJS()
    return header.header.isHide
  }
)



// WEBPACK FOOTER //
// ./src/selectors/header/header-selector.js